<template>
	<div>
		<div id="restaurant-booking-table"></div>
		<div class="chat-container w-100 position-relative bg-white" >
      <top-navbar
        title="Table Booking"
        :right_menu="false"
        :url="'/'+getMerchant.code"
      />
      <div class="w-100" style="height:60px;"></div>
      <div class="px-4 pt-4">
      	<!-- GUEST -->
      	<div class="w-100 box-shadow-primary mb-5 radius-12 p-3">
      		<p class="sub-heading-1-1 mb-0 mb-4">How many guests?</p>
      		<div class="row slim-grid-row mb-3 pb-3 border-bottom-dashed">
      			<div class="col-6 align-self-center">
      				<p class="mb-0 body-1-2">Adult</p>
      			</div>
      			<div class="col-6 align-self-center text-right">
      				<div class="d-inline-block align-middle cursor-pointer" @click="IncDecGuests('adult','dec')">
      					<img src="../../assets/img/icon/svg-dec.svg" height="28">
      				</div>
							<div class="d-inline-block align-middle px-3">
								<p class="mb-0 body-1-2 text-center">{{guests.adult}}</p>
							</div>
							<div class="d-inline-block align-middle cursor-pointer" @click="IncDecGuests('adult','inc')">
      					<img src="../../assets/img/icon/svg-inc.svg" height="28">
      				</div>			
      			</div>
      		</div>
      		<div class="row slim-grid-row">
      			<div class="col-6 align-self-center">
      				<p class="mb-0 body-1-2">Child</p>
      			</div>
      			<div class="col-6 align-self-center text-right">
      				<div class="d-inline-block align-middle cursor-pointer" @click="IncDecGuests('child','dec')">
      					<img src="../../assets/img/icon/svg-dec.svg" height="28">
      				</div>
							<div class="d-inline-block align-middle px-3">
								<p class="mb-0 body-1-2 text-center">{{guests.child}}</p>
							</div>
							<div class="d-inline-block align-middle cursor-pointer" @click="IncDecGuests('child','inc')">
      					<img src="../../assets/img/icon/svg-inc.svg" height="28">
      				</div>			
      			</div>
      		</div>
      	</div>

      	<!-- DATE -->
      	<div class="w-100 box-shadow-primary mb-5 radius-12 p-3">
      		<p class="sub-heading-1-1 mb-0 mb-4">When will you come?</p>
      		<v-date-picker 
		        v-model="dates.date"
		        :minDate="dates.min_date" 
		        mode="date">
		        <div class="row slim-grid-row mb-3 pb-3 border-bottom-dashed">
	      			<div class="col-6 align-self-center">
	      				<p class="mb-0 body-1-2">Date</p>
	      				<p class="mb-0 body-3-3-1">Click to change</p>
	      			</div>
	      			<div class="col-6 align-self-center">
	      				<p class="mb-0 text-green body-2-4 text-right">{{$formatDate(dates.date)}}</p>
	      			</div>
	      		</div>
		      </v-date-picker>
		      <div class="w-100">
		      	<p class="mb-3 body-1-2">Time</p>
		      	<div class="row pt-3 slim-grid-row">
		      		<template v-for="(time_data,index) in dates.time">
	              <div v-if="index < dates.qty_time_show" class="col-4 mb-3">
	                <div class="text-center rounded-6 p-2 border-2-solid-light delay cursor-pointer" :class="{'border-green bg-green-light':dates.time_selected == time_data}" @click="dates.time_selected = time_data">
	                  <p class="mb-0 body-2" style="color: #9c9c9c" :class="{'text-dark font-bold':dates.time_selected == time_data}">{{time_data}}</p>
	                </div>
	              </div>
              </template>
              <div 
              	class="col-12 cursor-pointer" 
              	v-if="dates.time.length > 6">
            		<p class="w-100 text-center py-2 body-2 text-orange mb-0" @click="toggleTime()">
            			{{more_time_text}}
            		</p>
              </div>
            </div>
		      </div>
      	</div>

      	<!-- CUSTOMER INFORMATION -->
      	<div class="w-100 box-shadow-primary mb-5 radius-12 p-3">
      		<p class="sub-heading-1-1 mb-0 mb-4">Whose name is this order?</p>
      		<div class="row slim-grid-row">
      			<div class="col-12 mb-3">
      				<p class="mb-0 body-3-3-1">Title<span class="text-danger font-weight-bold">*</span></p>
		      		<select v-model="customer.title" style="height: 47px" class="form-control body-3-1 mb-0">
                <option v-for="title_prefix in prefix" :value="title_prefix" class="body-3-1">{{title_prefix}}</option>
              </select>
      			</div>
      			<div class="col-6 mb-3">
      				<p class="mb-0 body-3-3-1">First Name<span class="text-danger font-weight-bold">*</span></p>
		      		<input type="text" class="form-control body-3-1 mb-0" style="height: 47px" v-model="customer.first_name" />
      			</div>
      			<div class="col-6 mb-3">
      				<p class="mb-0 body-3-3-1">Last Name</p>
		      		<input type="text" class="form-control body-3-1 mb-0" style="height: 47px" v-model="customer.last_name" />
      			</div>
      			<div class="col-12 mb-3">
      				<p class="mb-0 body-3-3-1">Email<span class="text-danger font-weight-bold">*</span></p>
		      		<input type="email" class="form-control body-3-1 mb-0" style="height: 47px" v-model="customer.email" />
      			</div>
      			<div class="col-12 mb-3">
      				<p class="mb-0 body-3-3-1">Phone Number<span class="text-danger font-weight-bold">*</span></p>
		      		<input type="email" class="form-control body-3-1 mb-0" style="height: 47px" v-model="customer.phone_number" />
      			</div>
      		</div>
      	</div>

      	<!-- NOTES -->
      	<div class="w-100 box-shadow-primary mb-5 radius-12 p-3">
      		<p class="sub-heading-1-1 mb-0 mb-4">Other special request?</p>
      		<div class="w-100">
      			<p class="mb-0 body-3-3-1">Notes</p>
		      	<textarea class="form-control body-3-1 mb-0" rows="3" v-model="note"></textarea>
      		</div>
      	</div>

      	<div class="w-100 pb-3">
      		<div class="w-100 mb-3">
		      	<ErrorMessage v-if="error_push != ''" :message="error_push" />
		      </div>
	        <button @click="submitForm" :disabled="push_loader" type="button" class="button-secondary w-100" :class="{'button-disabled': push_loader}">
	          <pulse-loader :loading="push_loader" color="#fff" v-if="push_loader"></pulse-loader>
	          <template v-else>
	            Confirm
	          </template>
	        </button>
	      </div>
      </div>
    </div>
	</div>
</template>
<script>
	import { post } from "@/services/index.js";
	import {mapGetters} from 'vuex'
	import moment from 'moment'

	export default{
		data(){
			return{
				guests:{
					adult: 1,
					child: 0
				},
				dates:{
					date: moment().add(1,'d').toDate(),
					time: [],
					time_selected: '',
					qty_time_show: 6,
					min_date: moment().toDate()
				},
				customer:{
					title: '',
					first_name: '',
					last_name: '',
					email: '',
					phone_number: ''
				},
				note: '',
				prefix:['Mr','Mrs', 'Miss'],
				error_push: '',
				push_loader: false
			}
		},
		computed:{
			...mapGetters(['getMerchant']),
			more_time_text(){
				return this.dates.qty_time_show < this.dates.time.length ? 'Show more' : 'Show Less'
			}
		},
		mounted(){
			document.getElementById("restaurant-booking-table").scrollIntoView({
	      behavior: "smooth",
	    });
	    this.generateTime()
		},
		methods:{
			generateTime(){
				let time_start = moment(this.getMerchant.time_start,'HH:mm:ss').toDate()
				let time_end = moment(this.getMerchant.time_end,'HH:mm:ss').subtract(30,'m').toDate()

				do {
					this.dates.time.push(moment(time_start).format("HH:mm"))
					time_start = moment(time_start).add(30,'m').toDate()
				} while (moment(time_start).isSameOrBefore(time_end))
			},
			toggleTime(){
				this.dates.qty_time_show = this.dates.qty_time_show == 6 ? this.dates.time.length : 6
			},
			IncDecGuests(field,type){
				if(type == 'dec'){
					if((field == 'adult' && this.guests[field] > 1) || (field == 'child' && this.guests[field] > 0)){
						this.guests[field]--
					}
				}else if(type == 'inc'){
					this.guests[field]++
				}
			},
			validateData(){
	    	if(this.dates.time_selected == ''){
	    		return 'Please select detail time to visit'
	    	}else if(this.customer.title == ''){
	    		return 'Please select title'
	    	}else if(this.customer.first_name == ''){
	    		return 'Please input first name'
	    	}else if(this.customer.email == ''){
	    		return 'Please input email'
	    	}else if(this.customer.phone_number == ''){
	    		return 'Please input phone number'
	    	}else{
	    		return true
	    	}
	    },
			submitForm(){
				this.error_push = ''
				this.push_loader = true
				let validate = this.validateData()
				if(validate != true){
					this.error_push = validate
					this.push_loader = false
				}else{
					let params = {
						customer_details:this.customer,
						guest_detail: this.guests,
						book_date: `${moment(this.dates.date).format('YYYY-MM-DD')} ${this.dates.time_selected}:00`,
						merchant: this.getMerchant.id,
						note: this.note
					}

					post("CORE_RESTO","v2/tx-booking-table",params).then(response=>{
						let res = response.data
						if(res.success){
              this.$router.push(`/${this.getMerchant.code}/restaurant/table-booking/result/${res.data.id}`)
            }else{
              this.error_push = res.message
            }
            this.push_loader = false
					}) 
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/restaurant/CartBookTable.vue